import React, { useState, useContext } from "react";

import { Box, Stack, ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps, Typography } from "@mui/material";

import { SettingsOptionsContext } from "../SettingsOptions";
import { FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from "@mui/icons-material";

interface SettingsToggleButtonProps extends ToggleButtonGroupProps {
  /**
   * Styling for the buttons in the button group.
   */
  buttonStyle?: Record<string, string | number>;
  /**
   * Acts as the identifier of the settings option.
   */
  keyid: string;
  /**
   * Label to be displayed in the UI
   */
  label: string;
  /**
   * List of options of either icons, or strings, or a combination
   */
  optionsList: { value: string, icon: any }[] | { value: string, text: string }[];
}

export const horizontalAlignmentOptions = [
  { icon: <FormatAlignLeft />, value: 'left' },
  { icon: <FormatAlignCenter />, value: 'center' },
  { icon: <FormatAlignRight />, value: 'right' },
];

export default function SettingsToggleButton(props: SettingsToggleButtonProps) {
  const settignsOptions = useContext(SettingsOptionsContext);
  const [alignment, setAlignment] = useState<string>(props.value ?? 'left');

  return (
    <Stack direction="row" sx={{
      alignItems: "center"
    }}>
      <Typography sx={{ flex: 1 }}>{props.label}</Typography>
      <Box sx={{ flex: 2, mr: 0 }}>
        <ToggleButtonGroup
          exclusive
          onChange={(e, newValue) => {
            settignsOptions?.updateSettingsState(props.keyid, newValue);
            setAlignment(newValue);
          }}
          size="small"
          value={alignment}
        >
          {props.optionsList.map(option => {
            return (
              'icon' in option
              ? <ToggleButton key={option.value} sx={{...props.buttonStyle}} value={option.value}>
                  {option.icon}
                </ToggleButton>
              : <ToggleButton key={option.value} sx={{...props.buttonStyle}} value={option.value}>
                  {option.value}
                </ToggleButton>
            )
          })}
        </ToggleButtonGroup>
      </Box>
    </Stack>
  );
}